import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

const PasswordInput = ({ style, className, ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <input {...props} type={show ? 'text' : 'password'} className={className} style={{ ...style, paddingRight: '44px' }} />
      <button type="button" onClick={() => setShow(!show)} aria-label={show ? 'Dölj lösenord' : 'Visa lösenord'}
        style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#888', display: 'flex' }}>
        {show ? <Eye size={20} /> : <EyeOff size={20} />}
      </button>
    </div>
  );
};

export default PasswordInput;
